/* global app */
/* global event */
/* global gui, navigator */
app.controller('archiveCtrl', ['$rootScope', '$scope', '$http', '$compile', 'NetworkService', 'AtlasDialog', 'AtlasNotification', function($rootScope, $scope, $http, $compile, NetworkService, AtlasDialog, AtlasNotification) {

    $scope.canShare = navigator.share;

    $scope.unArchiveEvent = function(eventId){
        
        NetworkService.callOperation("unArchiveEvent/"+eventId, {}, function(response){
            AtlasNotification.info("Das Event wurde erfolgreich Ent-Archiviert.");
        }) 
    }

}])
